import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { LISTING_STATE_DRAFT } from '../../util/types';
import { ensureOwnListing } from '../../util/data';
import { ListingLink } from '../../components';
import { EditListingLocationForm } from '../../forms';

import css from './EditListingLocationPanel.module.css';
 
class EditListingLocationPanel extends Component {
  constructor(props) {
    super(props);

    this.getInitialValues = this.getInitialValues.bind(this);

    this.state = {
      initialValues: this.getInitialValues(),
      count: this.props.listing.attributes.publicData.spotsNumber ? this.props.listing.attributes.publicData.spotsNumber : 1    
    };
  }

  getInitialValues() {
    const { listing } = this.props;
    const currentListing = ensureOwnListing(listing);
    const { geolocation, publicData } = currentListing.attributes;

    // Only render current search if full place object is available in the URL params
    // TODO bounds are missing - those need to be queried directly from Google Places
    const locationFieldsPresent =
      publicData && publicData.location && publicData.location.address && geolocation;
    const location = publicData && publicData.location ? publicData.location : {};
    const { address } = location;

    return {
      
      location: locationFieldsPresent
        ? {
            search: address,
            selectedPlace: { address, origin: geolocation },
          }
        : null,
    };
  }

  render() {
    const {
      className,
      rootClassName,
      listing,
      disabled,
      ready,
      onSubmit,
      onChange,
      submitButtonText,
      panelUpdated,
      updateInProgress,
      errors,
    } = this.props;

    const setCount = (value) => {
      this.setState({
        count: value
      })
    }

    const classes = classNames(rootClassName || css.root, className);
    const currentListing = ensureOwnListing(listing);

    const isPublished =
      currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
    const panelTitle = isPublished ? (
      <FormattedMessage
        id="EditListingLocationPanel.title"
        values={{ listingTitle: <ListingLink listing={listing} /> }}
      />
    ) : (<>
      {/* <FormattedMessage id="EditListingLocationPanel.createListingTitle" /> */}
        {/* <p className={css.locationTitle}>Pour pouvoir louer votre place de parking sur ollo, nous avons besoin que vous répondiez à quelques questions.</p>
        <p className={css.locationTitle}>Si vous n’avez pas toutes les informations en tête, pas d’inquiétude, vous pourrez y revenir plus tard, ou être mis en relation avec un membre de notre équipe pour effectuer un état des lieux de votre parking (photos, mesures etc…).</p> */}

      </>
    );
    const { publicData } = currentListing.attributes;
    console.log(this.props.listing)
    return (
      <div className={classes}>
        <h2 className={css.title}>{panelTitle}</h2>
        <EditListingLocationForm
          count={this.state.count}
          setCount={setCount}
          className={css.form}
          initialValues={{...this.state.initialValues,
            spotsNumber: publicData.spotsNumber}}
          onSubmit={values => {
            const { location } = values; // de modificat
            const temporaryTitle = location ? (location.search ? location.search.slice(0,location.search.indexOf(",")) : "") : "";
            const {
              selectedPlace: { address, origin },
            } = location;
            const updateValues = {
              title: temporaryTitle.trim(),
              geolocation: origin,
              publicData: {
                location: { address },
                spotsNumber : this.state.count // mutat state aici, prin props pana ajung
              }, 
            };
            this.setState({
              initialValues: {
                location: { search: address, selectedPlace: { address, origin } },
                spotsNumber: publicData.spotsNumber
              },
            });
            onSubmit(updateValues);
          }}
          onChange={onChange}
          saveActionMsg={submitButtonText}
          disabled={disabled}
          ready={ready}
          updated={panelUpdated}
          updateInProgress={updateInProgress}
          fetchErrors={errors}
        />
      </div>
    );
  }
}

const { func, object, string, bool } = PropTypes;

EditListingLocationPanel.defaultProps = {
  className: null,
  rootClassName: null,
  listing: null,
};

EditListingLocationPanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingLocationPanel;
